// @flow

import React from 'react';
import styled from 'styled-components';
import type { Theme } from '../../../../types';
import type { ColorScheme } from '../../../../types/theme';

type Props = {
  scheme: ColorScheme,
  icon: string,
};

const Icon = ({ icon, scheme }: Props) => (
  <StyledIcon icon={icon} scheme={scheme} className={`icon-${icon}`} />
);


const StyledIcon = styled<any, Theme, Props>('i')`
  font-size: .95rem;
  align-self: flex-start;

  color: ${props => props.scheme.icons || props.theme.list.listStyles[props.icon].color};
  flex-shrink: 0;
  margin-left: 0.2em;
  margin-right: calc(${props => props.theme.list.listStyles.size} - 0.9375em - 0.2em);
  margin-top: 0.2em;
  max-width: ${props => props.theme.list.listStyles.size};
  width: 0.9375em;
`;

export default Icon;
